/**
 * @class FormulaMoreInfo
 */
export default class FormulaMoreInfo {
    /**
     * @param {Number}          id
     * @param {String | null}   value
     * @param {Boolean}         hasImage
     */
    constructor(id, value, hasImage) {
        this._id = id;
        this._hasImage = hasImage;
        this.setValue(value);

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - FormulaMoreInfo");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String | null}
     */
    get value() {
        return this._value;
    }

    /**
     * @param {String | null}   value
     */
    set value(value) {
        this.setValue(value);
    }

    /**
     * @return {Boolean}
     */
    get hasImage() {
        return this._hasImage;
    }

    /**
     * @param {Boolean} hasImage
     */
    set hasImage(hasImage) {
        this._hasImage = hasImage;
    }

    /**
     * @param {String | null}   value
     */
    setValue = (value) => {
        if (typeof value === "string") {
            this._value = value.trim().length === 0 ? null : value;
        } else {
            this._value = null;
        }
    };
}
